import type { Booking } from '@brighterly/lib-core-types/booking/interfaces'
import type { Countdown } from '@brighterly/lib-core-types/support/interfaces'

import { getClockNumber } from '@shared/lib/format'
import { getDiffBetweenDates } from '@shared/lib/format'

const MS_SECOND = 1000
const MS_MINUTE = 60 * MS_SECOND
const MS_HOUR = 60 * MS_MINUTE
const MS_DAY = 24 * MS_HOUR

export const ZERO_COUNTDOWN: Countdown = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
  milliseconds: 0,
  totalDays: 0,
  totalHours: 0,
  totalMinutes: 0,
  totalSeconds: 0,
  totalMilliseconds: 0,
}

export const buildCountdown = (totalMilliseconds: number): Countdown => {
  const ms = Math.max(0, totalMilliseconds)
  return {
    days: Math.floor(ms / MS_DAY),
    hours: Math.floor((ms % MS_DAY) / MS_HOUR),
    minutes: Math.floor((ms % MS_HOUR) / MS_MINUTE),
    seconds: Math.floor((ms % MS_MINUTE) / MS_SECOND),
    milliseconds: Math.floor(ms % MS_SECOND),
    totalDays: Math.floor(ms / MS_DAY),
    totalHours: Math.floor(ms / MS_HOUR),
    totalMinutes: Math.floor(ms / MS_MINUTE),
    totalSeconds: Math.floor(ms / MS_SECOND),
    totalMilliseconds: ms,
  }
}

export const getCountdownValue = (value: number | undefined): string | null => {
  const valid = typeof value === 'number'
  const time = valid ? getClockNumber(value!) : null
  return time || null
}

const CANCEL_LEAD_HOURS = 6

export const isBookingWithinLeadHours = (booking: Booking, currentTime: string, hours: number): boolean => {
  const diff = getDiffBetweenDates(booking.start, currentTime).milliseconds
  return diff <= MS_HOUR * hours
}

export const isBookingCancelTime = (booking: Booking, currentTime: string): boolean =>
  isBookingWithinLeadHours(booking, currentTime, CANCEL_LEAD_HOURS)
